import React, { Component } from 'react'
import { DropdownItem } from 'reactstrap';
import { DropdownMenu, DropdownToggle, Dropdown } from 'reactstrap';
import CombinedShape from "../../../../images/CombinedShape.svg";
import { AxiosError, AxiosResponse } from 'axios';
import { toast } from 'react-toastify';
import moment from 'moment';
import Service from '../../../../services';
import { NotificationModel, NotificationTypeEnum, TodoModal } from './NotificationModal';
import { BankUserContext } from '../../../../bankUserContext';
import { catchError } from '../../../../utils/Utils';
import TodoViewDetails, { TodoStatus } from '../../../Widgets/Todos/ManualTodos/TodoViewDetails';
import { TodoHistoryDTO, TodoModel } from '../../../../models/TodoModel';
import { MessageModel, MessageThreadModel } from '../../../../models/MessageCenterModels';
import { ReactComponent as Notifications } from "../../../../images/Notifications.svg";
import './notification.scss'
import MessageCenterFC from '../../../MessageCenter/MessageCenterFC';
import { APP_Config } from '../../../../utils/AppConfig';
import MessageThreadsList from '../../../MessageCenter/MessageThreadsList';
import MessageThreadCard from '../../../MessageCenter/MessageThreadCard';
import MessageFormModal from '../../../MessageCenter/MessageFormModal';
import { messageCenterLandingConfig } from '../../../../config/MessageCenterConfig';
import { WithRouterProps, withRouter } from '../../../shared/WithRouter';

interface INotificationsRCState {
  notifications: NotificationModel[] | [];
  hasUnread: boolean;
  notificationModal: boolean;
  myTodoToggle: number;
  todoViewDetailsModal: boolean;
  viewTodoLoader: boolean;
  viewTodo: TodoModal | null;
  messageThread: MessageThreadModel | [];
  taskHistory: TodoHistoryDTO[] | [];
  messageModal: boolean;
  refreshCounter: number;
  notificationsInterval: any;
  conversation: any;
  todoViewLoader: boolean;
  reloadComponent: boolean;
  loader: boolean;
  todoData: TodoModel[] | [];
  selectedTodo: any;
}

class NotificationsRC extends Component<WithRouterProps<any>, INotificationsRCState> {
  service = new Service();
  // roles = new RolesAuthentication();
  static contextType = BankUserContext;
  context: React.ContextType<typeof BankUserContext> | undefined;


  constructor(props: any) {
    super(props);
    this.state = {
      notifications: [],
      hasUnread: false,
      notificationModal: false,
      myTodoToggle: -1,
      todoViewDetailsModal: false,
      viewTodoLoader: false,
      viewTodo: null,
      messageThread: [],
      conversation: {},
      taskHistory: [],
      messageModal: false,
      refreshCounter: 0,
      notificationsInterval: null,
      todoViewLoader: false,
      reloadComponent: false,
      loader: false,
      todoData: [],
      selectedTodo: null,
    }
  }

  toggleNotificationModal = () => {
    if (!this.state.notificationModal) {
      this.getNotifications();
      this.markAllNotifications();
    }
    this.setState({ notificationModal: !this.state.notificationModal });
  }

  setIsOpen = (indexNew: number) =>
    this.setState({ myTodoToggle: indexNew === this.state.myTodoToggle ? -1 : indexNew });

  // to get the list of notifications
  getNotifications = () => {
    const data = {
      "screen": "Notifications",
      "sections": "GetNotificationByUserId",
      "userId": this.context?.bankuserDetails?.userId,
      "isJsonReturnObject": false
    }
    this.service.getNotifications(data).then((response: AxiosResponse<NotificationModel[]>) => {

      const sortedResults: any = Array.isArray(response?.data) && response?.data?.sort(
        // sort according to created at
        (a: NotificationModel, b: NotificationModel) => {
          return (
            b.createdAt && a.createdAt ?
              (Date.parse(b.createdAt) - Date.parse(a.createdAt)) :
              a.createdAt ? -1 : 1
          );
        })?.sort((x, y) => { // sort unread, before read 
          return x?.isRead === y?.isRead
            ? 0
            : x?.isRead ? -1 : 1;
        }) || [];
      // check if any non notified notifications are present to display red dot
      for (let i = 0; i < sortedResults?.length; i++) {
        if (!sortedResults[i]?.notifyFlag) {
          this.setState({ hasUnread: true })
          break;
        }
      }
      this.setState({ notifications: sortedResults });
    });
  };

  // makes a single notification read or unread based on the uuid passed and read/unread
  readNotification = (element: NotificationModel, e?: MouseEvent) => {
    e && e.stopPropagation();
    const data = {
      "notificationType": element?.notificationType,
      "id": element?.id,
      "isNotificationDelete": false,
      "isRead": !element.isRead,
      "isManual": element?.isManual,
    }
    element?.id && this.service.deleteNotifications(data)
      .then(() => this.getNotifications())
      .catch((error: AxiosError) => catchError(error, true))

  }

  // changes notifyFlag to true for all notifications
  markAllNotifications = () => {
    this.service.updateNotificationFlag()
      .then(() => setTimeout(() => this.setState({ hasUnread: false }), 2000))
      .catch((error: AxiosError) => {
        catchError(error, true);
      })
  };

  // deletes the notification
  deleteNotification = (element: NotificationModel, e: MouseEvent) => {
    e.stopPropagation();
    const data = {
      "notificationType": element?.notificationType,
      "id": element?.id,
      "isNotificationDelete": true,
      "isRead": false,
      "isManual": element?.isManual,
    }
    element?.id && this.service.deleteNotifications(data)
      .then(() => this.getNotifications())
      .catch((error: AxiosError) => catchError(error, true))
  }

  handleNotificationClick = (element: NotificationModel) => {
    
    if (element?.notificationType === NotificationTypeEnum.MESSAGE) {
      this.getMessageThreads(element?.id);
      this.setState({ conversation: { ...element, subject: element.notification }, messageModal: true })
    } else if (element?.notificationType === NotificationTypeEnum.TODO && !element?.isManual) {
      const url = `/${element?.redirectUrl}/${element?.clientId}/${element.clientProductsId}`

      if (element.todoTypeId !== 5 &&
        element.todoTypeId !== 2 && element.todoTypeId !== 4 && element.clientId) {
        if ((element.todoTypeId === 3 || element.todoTypeId === 1) && element.status === "active") {
          element.clientActionId && localStorage.setItem("clientActionId", element.clientActionId);
        } else if((element.todoTypeId === 3 || element.todoTypeId === 1) && (element.status !== "active")){
          element.clientActionId && localStorage.setItem("status", element.status);
        }
        this.props.navigate(url);
      }
    }
    else if (element?.notificationType === NotificationTypeEnum.TODO && element?.isManual) {
      this.handleViewDetails(element)
    }
    else if ((element.todoTypeId === 4 || element.todoTypeId === 5) && element.caseId) {
      const url = `/caseTracker/details/${element.caseId}`
      this.props.navigate(url);
    }
    if (!element?.isRead) {
      this.readNotification(element);
    }
    !element?.notificationType && this.setState({ notificationModal: false });

  }

  componentDidMount = () => {
    const currentUrl = window.location.href;
    if (!currentUrl.includes("sessiontimeoutpage")) {
      this.getNotifications();
    }
    const time = APP_Config().REACT_APP_RELOAD_TIME !== undefined ?
      parseInt(APP_Config().REACT_APP_RELOAD_TIME) * 60 * 1000 : 0;
    if (time && !currentUrl.includes("sessiontimeoutpage")) {
      this.setState({
        notificationsInterval: setInterval(() => this.getNotifications(), time)
      });
    }
  }

  componentWillUnmount = () => {
    clearInterval(this.state.notificationsInterval)
  }
  setSelectedTodo = (value: any) =>{
    this.setState({ selectedTodo: value });
  }
  // todo modal functions
  setViewTodo = (value: TodoModal | null) => this.setState({ viewTodo: value });

  setViewTodoLoader = (value: boolean) => this.setState({ viewTodoLoader: value });

  resetAllStates = () => {
    this.setState({
      viewTodo: null,
      messageThread: [],
      taskHistory: [],
    })
  }
  handleViewDetails = (element: any) => {    
      if (element?.status === TodoStatus.Open && element.todoTypeId !== 5 &&
      element.todoTypeId !== 2 && element.clientId) {
      // this.getTodo();
      
      this.setSelectedTodo(element);
      this.handleStatusChange(element, TodoStatus.In_Progress, true);
      
      this.toggleViewDetails(element?.id);
    } else {
      // this.getTodo();
      
      this.setSelectedTodo(element);
      this.toggleViewDetails(element?.id);
    }

    
  };

  toggleViewDetails = (id?: string) => {
    const payload = {
      "todoUuid": id,
      "isJsonReturnObject": false,
      "screen": "LandingPage",
      "sections": "GetTodoById"
    }
    if (this.state.todoViewDetailsModal) {
      this.resetAllStates();
    } else {
      id && this.getTodoById(payload, true, true);
    }
    this.setState({ todoViewDetailsModal: !this.state.todoViewDetailsModal })
  }
  reloadComponent = () => this.setState({ reloadComponent: !this.state.reloadComponent });
  toggleTodoViewLoader = (value?: boolean) =>
    this.setState({
      todoViewLoader: value ?? !this.state.todoViewLoader,
    });
  getTodo = () => {
    let data: any = {
      screen: "LandingPage",
      sections: "GetTodos",
      isJsonReturnObject: false,
    };
    if (this.context?.bankuserDetails) {
      data = {
        ...data,
        userId: this.context?.bankuserDetails.userId,
      };
    }
    if (
      this.props.interactionData.length > 0 &&
      this.context?.bankuserDetails
    ) {
      // for filtering only action items todos
      data = {
        screen: "LandingPage",
        sections: "GetTodos",
        todoTypeId: 3,
        interactionId: this.props.interactionData,
        userId: this.context?.bankuserDetails.userId,
        isJsonReturnObject: false,
      };
    }
    this.setState({ loader: true });
    this.service
      .getTodoListByUserId(data)
      .then((res: AxiosResponse<TodoModel[]>) => {
        this.setState({ todoData: res?.data || [] });
      })
      .catch((err) => catchError(err, true))
      .finally(() => {
        this.setState({ loader: false });
      });
  };

  updateTodo = (data: any) => {
    return this.service.updateTodo(data);
  };
  todoFlagged = (element: TodoModel | null, priority: number) => {

    if (element) {
      if (!element.isManual) {
        const data = {
          sections: "updateTodo",
          todoUuid: element.todoUuid,
          priority: priority,
          status: element.status,
          assignedTo: this.context?.bankuserDetails?.userId,
        };

        this.updateTodo(data)
          .then((response: AxiosResponse<string>) => {
            toast.success(
              `${priority === 2 ? "Todo Flagged" : "Todo Unflagged"}`,
              {
                position: toast.POSITION.TOP_RIGHT,
              }
            );
            this.getTodo();
            this.reloadComponent();
          })
          .catch((err: AxiosError) => catchError(err, true))
          .finally(() => this.setState({ loader: false }));
      }

      if (element.isManual) {
        const data = {
          sections: "updateTodo",
          todoUuid: element.todoUuid,
          isManual: true,
          priority: priority,
          status: element.status,
          assignedTo: element.assigned,
        };
        this.service
          .updateManualTodo(data)
          .then(() => {
            toast.success(
              `${priority === 2 ? "Todo Flagged" : "Todo Unflagged"}`,
              {
                position: toast.POSITION.TOP_RIGHT,
              }
            );
            this.getTodo();
            this.reloadComponent();
          })
          .catch((err: AxiosError) => catchError(err, true))
          .finally(() => this.setState({ loader: false }));
      }
    }

  };
  handleStatusChange = (todo: TodoModel | any, status: string, reloadSingle = false) => {
    if (todo.referenceId) {
      this.service.todoStatusChange(todo.referenceId, status)
        .then((response: AxiosResponse<string>) => {
          toast.success(response.data);
          // this.getTodo();
          reloadSingle && this.toggleViewDetails();
          this.reloadComponent();
        })
        .catch((err: AxiosError) => catchError(err, true));
    }

    if (todo.isManual) {
      const data = {
        sections: "updateTodo",
        todoUuid: todo.todoUuid,
        isManual: true,
        priority: todo.priority,
        status: status,
        assignedTo: todo.assigned,
      };
      this.service
        .updateManualTodo(data)
        .then((response: AxiosResponse<any>) => {
          toast.success("Manual Todo Updated");
          this.getTodo();
          reloadSingle && this.toggleViewDetails();
          this.reloadComponent();
        })
        .catch((error: AxiosError) => {
          catchError(error, true);
        });
    }
  };
  getTodoById = async (data: any, displayLoader = true, checkStatus = false) => {
    displayLoader && this.setViewTodoLoader(true);
    this.service.getTodoById(data)
      .then((res: AxiosResponse<TodoModal>) => {
        if (checkStatus && res?.data?.status === TodoStatus.Open && res?.data?.todoType !== "Task") {
          this.handleStatusChange(res?.data, TodoStatus.In_Progress, true)
        } else {
          this.setSelectedTodo(res?.data)
        }
      })
      .catch((err: AxiosError) => catchError(err, true))
      .finally(() => displayLoader && this.setViewTodoLoader(false));
  }

  getMessageThreads = (contextId?: string | null) => {
    contextId && this.service
      .getMessages(contextId)
      .then((res: AxiosResponse<MessageThreadModel>) => this.setState({ messageThread: res?.data }))
      .catch((error: AxiosError) => catchError(error, true));
  };


  toggleMessageModal = () => {
    if (this.state.messageModal) {
      this.resetAllStates();
    }
    this.setState({ messageModal: !this.state.messageModal })
  }

  messageSend = () => this.setState({ refreshCounter: this.state.refreshCounter + 1 })

  // return elements ---
  messageSecondLine = (message: NotificationModel) => {
    if (message?.clientCompany && message?.userDisplayFirstName && message?.userDisplayLastName) {
      return `${message?.userDisplayFirstName || "--"} ${message?.userDisplayLastName} (${message?.clientCompany})`
    } else if (!message?.clientCompany && message?.userDisplayFirstName && message?.userDisplayLastName) {
      return `${message?.userDisplayFirstName || "--"} ${message?.userDisplayLastName}`
    } else {
      return `${message?.userDisplayFirstName || "--"} ${message?.userDisplayLastName}`
    }
  }

  todoSecondLine = (todoNotification: NotificationModel) => {
    if (todoNotification?.isManual) {
      return "General"
    } else return todoNotification?.clientCompany || "--"
  }

  notificationTile = (element: NotificationModel, index: number) => (
    <div key={index}>
      <div
        className={`notificationWrapper ${element?.isRead ? "" : "unread"}`}
        onClick={() => this.handleNotificationClick(element)}
      >
        <div className={!element?.isRead ? "oval" : "noOval"}></div>
        <div className="notificationsElement">
          <div className="left">
            <div className="text1">
              {element?.isMessage ? "New Message" : "New Task in To Do’s"}
            </div>
            <div className="text2">
              {
                element?.isMessage ? this.messageSecondLine(element) : this.todoSecondLine(element)
              }
            </div>{" "}

            <div className="text3">
              {element?.notification}
            </div>{" "}
          </div>
          <div className="right">
            <div className="time">{element?.createdAt ? moment(element.createdAt).fromNow() : "--"}</div>
            <div className="notificationOption">
              <Dropdown
                className="img"
                toggle={(e: React.MouseEvent) => { e.stopPropagation(); this.setIsOpen(index); }}
                isOpen={index == this.state.myTodoToggle}
              >
                <DropdownToggle>
                  <img className='combinedShape' src={CombinedShape} alt="nothing" />
                </DropdownToggle>
                <DropdownMenu className="notificationsMenuInner footerOptions">
                  <DropdownItem className='markas' onClick={(e: any) => this.readNotification(element, e)}>
                    {element?.isRead ? "Mark as Unread" : "Mark as Read"}
                  </DropdownItem>
                  <DropdownItem className='delete' onClick={(e: any) => this.deleteNotification(element, e)}>
                    Delete
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
      <div className={`${index === this.state.notifications?.length - 1 ? "" : "line"}`}></div>
    </div>
  )

  render() {
    return (
      <div className="bell" >
        <Dropdown
          toggle={this.toggleNotificationModal}
          isOpen={this.state.notificationModal}
        >
          <DropdownToggle >
            <div className="notofication-wrap">
              <Notifications />
            </div>
            {this.state.hasUnread ? <span className="bellNotification"></span> : <></>}
          </DropdownToggle>
          <DropdownMenu right className="notificationsMenuMain">
            <div className='notificationsmodalbody'>
              {
                this.state.notifications?.length > 0 ?
                  this.state.notifications?.sort(
                    (a: NotificationModel, b: NotificationModel) =>
                      (a.isRead === b.isRead ? 0 : (a.isRead ? 1 : -1))
                  )?.map((element: NotificationModel, index: number) => this.notificationTile(element, index))
                  : <h4 className='noNotifications'>No Notifications found.</h4>
              }
            </div>
          </DropdownMenu>
        </Dropdown>

        {/* todo-message modals */}
        {this.state.todoViewDetailsModal && this.state.selectedTodo?.[0]?.todoUuid && (
          <TodoViewDetails
            todoViewDetailsModal={this.state.todoViewDetailsModal}
            toggleViewDetails={this.toggleViewDetails}
            todoViewLoader={this.state.todoViewLoader}
            toggleTodoViewLoader={this.toggleTodoViewLoader}
            todoUuid={this.state.selectedTodo?.[0]?.todoUuid}
            selectedTodo={Array.isArray(this.state.selectedTodo) ? this.state.selectedTodo[0] : this.state.selectedTodo} // todo
            todoFlagged={this.todoFlagged}
            handleStatusChange={this.handleStatusChange}
            reloadComponent={this.state.reloadComponent}
            getTodo={this.getTodo}
          />
        )}
        {/* {
          this.state.todoViewDetailsModal && 
          <TodoViewDetails
            todoViewDetailsModal={this.state.todoViewDetailsModal}
            toggleViewDetails={this.toggleViewDetails}
            todoFlagged={this.todoFlagged}
            handleStatusChange={this.handleStatusChange}
            getTodoById={this.getTodoById}
            viewTodo={this.state.viewTodo}
            setViewTodo={this.setViewTodo}
            viewTodoLoader={this.state.viewTodoLoader}
            setViewTodoLoader={this.setViewTodoLoader}
            getMessageThreads={this.getMessageThreads}
            messageThread={this.state.messageThread}
            getManualTodoHistory={this.getManualTodoHistory}
            taskHistory={this.state.taskHistory}
            disableforsuperuser={true}
          />
        } */}

        {/* <div className="conversationsBox">
        {this.state?.messageThread?.length > 0 ? (
          this.state?.messageThread?.map((each:any) => (
            <MessageThreadCard
              key={each?.id}
              messageThread={each}
              isActive={isActive(each)}
              handleTreadClick={this.handleNotificationClick}
              // config={config}
              // quickMessageReply={quickMessageReply}
            />
          ))
        ) : (
          <p className="noMessages">
           
          </p>
        )}
      </div> */}

        {this.state.conversation ? (
          <MessageFormModal
            messagesModal={this.state.messageModal}
            config={messageCenterLandingConfig}
            toogleMessagesModal={this.toggleMessageModal}
            conversation={this.state.conversation}
            setConversation={(data) => { this.setState({ conversation: data }) }}
          />
        ) : (
          <></>
        )}


        {/* todo-message modals */}
      </div>
    )
  }
}

export default withRouter<WithRouterProps<any>>(NotificationsRC);
